import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import StoreUtil from "../store.util.js";

const state = {
  groupList: StoreUtil.state(),
};

const groupGroupModule = {
  state,
  mutations,
  actions,
  getters,
};

export default groupGroupModule;
